/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Of_ContentsInputs */

const en_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table of Contents`)
};

const es_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabla de contenidos`)
};

const fr_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table des matières`)
};

const de_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaltsverzeichnis`)
};

const ja_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目次`)
};

const zh_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录`)
};

const ar_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جدول المحتويات`)
};

const id_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar Isi`)
};

const it_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sommario`)
};

const ru_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оглавление`)
};

const pt_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Índice`)
};

const ko_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`목차`)
};

/**
* | output |
* | --- |
* | "Table of Contents" |
*
* @param {Table_Of_ContentsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const table_of_contents = /** @type {((inputs?: Table_Of_ContentsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Of_ContentsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_of_contents(inputs)
	if (locale === "es") return es_table_of_contents(inputs)
	if (locale === "fr") return fr_table_of_contents(inputs)
	if (locale === "de") return de_table_of_contents(inputs)
	if (locale === "ja") return ja_table_of_contents(inputs)
	if (locale === "zh") return zh_table_of_contents(inputs)
	if (locale === "ar") return ar_table_of_contents(inputs)
	if (locale === "id") return id_table_of_contents(inputs)
	if (locale === "it") return it_table_of_contents(inputs)
	if (locale === "ru") return ru_table_of_contents(inputs)
	if (locale === "pt") return pt_table_of_contents(inputs)
	return ko_table_of_contents(inputs)
});